import { render, staticRenderFns } from "./DomainReplaceContent.vue?vue&type=template&id=553b2db6"
import script from "./DomainReplaceContent.vue?vue&type=script&lang=js"
export * from "./DomainReplaceContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports